module.exports = __webpack_public_path__ + "img/n12.65dc2b64.png";